import { type FC, type ReactNode, useLayoutEffect, useState } from "react"
import { createPortal } from "react-dom"

const Portal: FC<{ children: ReactNode }> = ({ children }) => {
	const [container, setContainer] = useState<HTMLDivElement>()

	useLayoutEffect(() => {
		const element = document.createElement("div")
		// Lets an open Modal include later portals (menus and pickers opened from it) in its focus trap.
		element.dataset.portal = ""
		document.body.appendChild(element)
		setContainer(element)

		return () => {
			document.body.removeChild(element)
			setContainer(undefined)
		}
	}, [])

	if (container === undefined) return null

	return createPortal(children, container)
}

export default Portal
